export enum UserAccess {
  Free = 'Free',
  Premium = 'Premium',
  Founder = 'Founder',
  Visitor = 'Visitor',
}

export interface AuthInfos {
  userAccess: UserAccess,
  userCompany?: string,
  userAirTableId: string,
  userEmail: string,
}

export const authInfosDefaults: AuthInfos = {
  userAccess: UserAccess.Visitor,
  userCompany: undefined,
  userAirTableId: '',
  userEmail: ''
}
